import { Button, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { route, RouterName } from "core/router";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { getFieldInputProps } from "core/utils/form";
import { _t } from "core/language";
import BottomNavigation from "core/layouts/BottomNavigation";
import { validationSchemaConfirmPassword } from "modules/Auth/pages/Auth.config";
import API from "core/networks/API";
import { API_VERIFY_PASSWORD } from "../api";
import { useRecipe } from "modules/Ingredients/hooks/recipe";


const ConfirmPassword = () => {
  const { resetRecipes } = useRecipe()
  const navigate = useCustomNavigate();
  

  const formik = useFormikCustom({
    initialValues: {
      password: "",
    },
    validationSchema:validationSchemaConfirmPassword,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values, formikHelpers) {
      console.log(values, formikHelpers)
      handleSubmitComfirmPassword()
      
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmitComfirmPassword = async () => {
    const dataRequest = {
      password: formik.values.password,
    }
    
    try {
      const { data: response } = await API.post(`${API_VERIFY_PASSWORD}`, dataRequest)
      if (response && response?.code === 200) {
        console.log('chang success')
        navigate(route(RouterName.CHANGE_PASSWORD))
      }
    } catch (e: any) {
      console.log(e, 'errors')
      if (e?.response?.data?.code === 400) {
        formik.setErrors({ password: _t('auth.MI_02_MSG_01') })
      }
      if (e?.response?.data?.code === 422) {
        formik.setErrors({ password: _t('auth.MI_02_MSG_01') })
      }
    }
  }

  const handleSubmit = (e: any) => {
    const { onSubmit, errors } = formik;
    console.log(errors, 'errors')
    onSubmit(e)
  };

  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader sticky title={_t('auth.VerifyPassword')} handleGoBack={handleGoBack} />
      <div className="">
        <form onSubmit={handleSubmit} className="flex flex-col px-4 py-12 w-full ">
          <div>
            <CInputControl
              className=" "
              label={_t('auth.CurrentPassword')}
              error=""
              maxLength={200}
              type="password"
              placeholder={_t('auth.PlaceHolderPassword')}
              {...getFieldInputProps(formik, 'password')}
            />
          </div>
          <div className="absolute left-0 bottom-[60px] w-full px-4">
            <Button disabled={!formik.values.password ? true : false} size="lg" type="submit" label={_t('auth.Confirm')} classBtn="w-full mb-[50px] font-medium" />
          </div>
        </form>
      </div >
      <BottomNavigation activeIndex={5} onNavigateChange={resetRecipes} />
    </AppLayout >
  );
};

export default ConfirmPassword;
